import { render, staticRenderFns } from "./hotNews.vue?vue&type=template&id=4312ab7d&scoped=true&"
import script from "./hotNews.vue?vue&type=script&lang=js&"
export * from "./hotNews.vue?vue&type=script&lang=js&"
import style0 from "./hotNews.vue?vue&type=style&index=0&id=4312ab7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312ab7d",
  null
  
)

export default component.exports